import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type UpdateKeyDateV3 = OpalApi<'UpdateKeyDateV3', 200>

export const updateKeyDate: UpdateKeyDateV3 = async (args = {}) => {
  const url = new URL(
    `/loupe/v3/key_dates/${args.params?.path.key_date_id}`,
    window.location.origin
  )

  return HttpClient()
    .patch(url.toString(), args.requestBody)
    .then((res) => res.data)
}
